/* eslint-disable */
import CheckboxTitle from "~/ui/checkboxTitle";
import { node } from "~/util/dom";

interface ISettingsCheckbox {
	title: string;
	desc: string;
	checked: boolean;
	change: (checked: boolean) => void;
}

export default class SettingsCheckbox {
	#container: HTMLDivElement;

	#opts: ISettingsCheckbox;

	#checkboxTitle: CheckboxTitle;

	constructor(optsArg: Partial<ISettingsCheckbox>) {
		this.#opts = {
			title: "Title",
			desc: "Description",
			checked: false,
			change: _checked => {},
			...optsArg,
		};
		this.#container = node("div", { className: "settings-checkbox" });

		this.#build();
	}

	destroy() {
		this.#checkboxTitle.destroy();
	}

	get container() {
		return this.#container;
	}

	#build() {
		const topLine = node("div", { className: "top-line" });
		const title = node("h3", { className: "title", textContent: this.#opts.title, title: this.#opts.title });

		this.#checkboxTitle = new CheckboxTitle({
			checked: this.#opts.checked,
			change: this.#opts.change,
		});

		topLine.appendChild(title);
		topLine.appendChild(this.#checkboxTitle.container);
		this.#container.appendChild(topLine);
		this.#container.appendChild(node("p", { className: "desc", textContent: this.#opts.desc }));
	}
}
